// extracted by mini-css-extract-plugin
module.exports = {"tag_input":"tag_input_tag_input__2zTUS"};